import { DTMF_COMMANDS } from '../../../../../../../shared/features/room-agent/dtmf/dtmf-commands';
import { i18n } from '../../../../../../../shared/helpers/i18n';
import { CONTAINER_BORDER_RADIUS, FONT_FAMILY, FOOTER_BACKGROUND_COLOR, TEXT_COLOR_PRIMARY } from '../constants';
import { drawDTMFChar, DTMFCharColor } from '../dtmf-char';
import { Area, Coordinates, Drawer } from '../types';
import { SCALE } from './constants';

export const CONTROLS_HEIGHT = Math.round(60 * SCALE);

const CONTROLS_FONT_SIZE = Math.round(18 * SCALE);
const CONTROLS_FONT = `${CONTROLS_FONT_SIZE}px ${FONT_FAMILY}`;
const CONTROL_ITEM_ICON_SIZE = Math.round(28 * SCALE);
const CONTROL_ITEM_FONT_SIZE = Math.round(36 * SCALE);
const CLOSE_CHAR_OFFSET_Y = Math.round(-1 * SCALE);

export class ControlsDrawer implements Drawer {
    private fullArea: Area;
    private contentArea: Area;
    private controlCoordinates?: { text: Coordinates; icon: Coordinates };
    private controlMessage?: string;

    constructor(fullArea: Area, contentArea: Area) {
        this.fullArea = fullArea;
        this.contentArea = contentArea;
    }

    private getControlCoordinates(
        ctx: CanvasRenderingContext2D,
        message: string
    ): { text: Coordinates; icon: Coordinates } {
        if (!this.controlCoordinates) {
            ctx.textBaseline = 'top';
            ctx.font = CONTROLS_FONT;

            const textMetrics = ctx.measureText(message);
            const textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
            const textOffsetY = Math.round((CONTROLS_HEIGHT - textHeight) / 2);
            const text: Coordinates = {
                x: this.contentArea.x,
                y: this.contentArea.y + textOffsetY,
            };

            const iconOffsetY = (CONTROLS_HEIGHT - CONTROL_ITEM_ICON_SIZE) / 2;
            const icon: Coordinates = {
                x: this.contentArea.x + this.contentArea.width - CONTROL_ITEM_ICON_SIZE,
                y: this.contentArea.y + iconOffsetY,
            };

            this.controlCoordinates = { icon, text };
        }

        return this.controlCoordinates;
    }

    private drawFullArea(ctx: CanvasRenderingContext2D) {
        ctx.beginPath();
        ctx.fillStyle = FOOTER_BACKGROUND_COLOR;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ctx.roundRect(this.fullArea.x, this.fullArea.y, this.fullArea.width, this.fullArea.height, [
            0,
            0,
            CONTAINER_BORDER_RADIUS,
            CONTAINER_BORDER_RADIUS,
        ]);
        ctx.fill();
    }

    private drawControl(ctx: CanvasRenderingContext2D) {
        const message = this.controlMessage || i18n('dtmf', 'common.close');

        // Сейчас переводы могут не успеть загрузиться. Возможно в будущем это уже исправлено
        if (!message) {
            return;
        }

        const coordinates = this.getControlCoordinates(ctx, message);

        ctx.textBaseline = 'top';
        ctx.font = CONTROLS_FONT;
        ctx.fillStyle = TEXT_COLOR_PRIMARY;
        ctx.fillText(message, coordinates.text.x, coordinates.text.y);

        drawDTMFChar({
            ctx,
            x: coordinates.icon.x,
            y: coordinates.icon.y,
            char: DTMF_COMMANDS.common.close,
            color: DTMFCharColor.accent,
            size: CONTROL_ITEM_ICON_SIZE,
            fontSize: CONTROL_ITEM_FONT_SIZE,
            charOffsetY: CLOSE_CHAR_OFFSET_Y,
        });
    }

    public draw(ctx: CanvasRenderingContext2D) {
        this.drawFullArea(ctx);
        this.drawControl(ctx);
    }
}
